
import { Component, Prop, Vue } from 'vue-property-decorator';

const convertToSentenceCase = (str: string) => str[0].toUpperCase() + str.slice(1);

interface Message {
  type: string;
  display_name: string;
  new_rating: string;
}

@Component
export default class SystemMessage extends Vue {
  @Prop({ default: () => {} }) readonly message!: object;

  get getMessageByType () {
    switch ((this.message as Message).type) {
      case 'chat.memberjoin':
        return `${(this.message as Message).display_name} has joined the chat`;
      case 'chat.memberleave':
        return `${(this.message as Message).display_name || 'Agent'} has left the chat`;
      case 'chat.rating':
        if (!(this.message as Message).new_rating) {
          return 'You have removed the chat rating';
        } else {
          const rating = convertToSentenceCase((this.message as Message).new_rating);
          return `You have rated the chat service ${rating}`;
        }
      default:
        return JSON.stringify(this.message);
    }
  }
}
